<template>


  <TransitionRoot as="template" :show="open" v-if="(null !== company) && !displayCreateListDialog">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="$emit('close')" ref="firstDialog"
            :initialFocus="addCompanyToListDoneButtonRef">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                         leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-95 transition-opacity"/>
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300"
                         enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                         enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                         leave-from="opacity-100 translate-y-0 sm:scale-100"
                         leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
              class="inline-block align-bottom bg-white rounded-lg p-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl w-full sm:p-6">
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                  type="button"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                  @click="$emit('close')"
              >
                <span class="sr-only">Close</span>
                <XIcon class="h-6 w-6" aria-hidden="true"/>
              </button>
            </div>

            <div class="mt-3 text-center sm:mt-0  sm:text-left">
              <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                Save to list
              </DialogTitle>
              <div class="mt-2">
                <p class="text-sm text-gray-500 pb-2">
                  {{ company.name }}
                </p>
                <div class="border-b border-gray"></div>
                <!-- Content -->
                <div class="overflow-hidden overflow-y-auto mt-4" style="height: 7.3125rem">
                  <div v-for="(channel, idx) in getCompanyChannels"
                       :key="'company-list-`${idx}`'"
                       class="text-sm font-medium">
                    <div class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 ">
                      <div class="w-full pr-3">
                        <div class="py-1 sm:flex sm:items-center sm:justify-between">
                          <h3 class="text-sm leading-6 font-medium text-gray-900 inline-flex items-center justify-center">
                            <ViewListIcon class="h-4 w-4"></ViewListIcon>
                            <span class="ml-2"> {{ channel.label }}</span>
                          </h3>
                          <div class="sm:mt-0 sm:ml-4">
                            <button v-if="!(channel.uuid in addedToChannel)"
                                    @click="addCompanyToChannel(channel)"
                                    type="button"
                                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-2 py-1 bg-white text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none active:bg-ternary active:text-white active:border-white sm:mt-0 sm:w-auto sm:text-sm">
                              Add
                            </button>
                            <button v-else
                                    disabled="true"
                                    type="button"
                                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-2 py-1 bg-white text-sm font-medium text-gray-700 cursor-not-allowed bg-gray-100 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm">
                              Done
                            </button>
                          </div>
                        </div>
                        <p v-show="false" class="mt-2 text-sm text-red-600" id="email-error">Email is not valid.</p>
                      </div>

                    </div>
                    <p v-show="false" class="mt-2 text-sm text-red-600"></p>
                  </div>
                  <!-- End Content -->
                </div>

              </div>
            </div>

            <div class="mt-6 sm:flex sm:flex-row-reverse">
              <button
                  type="button"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-ternary-500 text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm hover:bg-ternary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ternary-500"
                  @click="$emit('close')"
                  ref="addCompanyToListDoneButtonRef"
              >
                Done
              </button>
              <button
                  @click="displayCreateNewListDialog()"
                  type="button"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
              >
                Create new list
              </button>
            </div>

          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>


  <TransitionRoot as="template" :show="open" v-else>
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="displayCreateListDialog=false"
            :initial-focus="newListNameInputRef">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                         leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-95 transition-opacity"/>
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300"
                         enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                         enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                         leave-from="opacity-100 translate-y-0 sm:scale-100"
                         leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
              class="inline-block align-bottom bg-white rounded-lg p-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6">
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                  type="button"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                  @click="displayCreateListDialog=false"
              >
                <span class="sr-only">Close</span>
                <XIcon class="h-6 w-6" aria-hidden="true"/>
              </button>
            </div>

            <div class="mt-3 text-center sm:mt-0  sm:text-left">
              <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                Create new list
              </DialogTitle>
              <div class="mt-2">
                <p class="text-sm text-gray-500 pb-2">
                  Enter a name to create a new list
                </p>
                <div class="border-b border-gray"></div>
                <!-- Content -->
                <div class="mt-4" style="height: 7.3125rem">
                  <div class="text-sm font-medium">
                    <div class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 ">
                      <div class="w-full pr-3">
                        <div class="py-1 sm:flex sm:flex-col">

                          <label for="list-name" class="block text-sm font-medium text-gray-700">
                            List name
                          </label>
                          <div class="mt-1">
                            <input type="text" name="list-name" id="list-name" autocomplete="false"
                                   class="shadow-sm focus:outline-none focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                   v-model.trim="newListName"
                                   @keyup.enter="createChannel()"
                                   ref="newListNameInputRef"
                            />
                          </div>


                        </div>
                        <p v-show="false" class="mt-2 text-sm text-red-600" id="new-list-error">Email is not valid.</p>
                      </div>
                    </div>

                    <p v-show="false" class="mt-2 text-sm text-red-600"></p>
                  </div>
                  <!-- End Content -->
                </div>

              </div>
            </div>

            <div class="mt-6 sm:flex sm:flex-row-reverse">
              <button
                  type="button"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-ternary-500 text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm hover:bg-ternary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ternary-500"
                  @click="createChannel()"
              >
                Create list
              </button>
              <button
                  @click="(null !== company) ? displayCreateListDialog=false : $emit('close')"
                  type="button"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm"
              >
                Cancel
              </button>
            </div>

          </div>
        </TransitionChild>
      </div>
    </Dialog>

  </TransitionRoot>


</template>

<script>


import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {ViewListIcon, XIcon} from "@heroicons/vue/outline";
import {mapGetters, mapState} from "vuex";
import {ref} from "vue";
import _get from "lodash/get";

export default {
  name: "SaveToList",
  emits: ['close'],
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    XIcon,
    ViewListIcon
  },
  setup() {
    let newListNameInputRef = ref(null);
    let addCompanyToListDoneButtonRef = ref(null);
    return {
      newListNameInputRef, addCompanyToListDoneButtonRef
    }
  },
  props: [
    "open", "company",
  ],
  data() {
    return {
      displayCreateListDialog: false,
      newListName: null,
      addedToChannel: {},
    }
  },
  created() {
    if (null === this.company) {
      this.displayCreateNewListDialog();
      return;
    }

    this.addedToChannel = this.getChannelsForCompany(this.company.id);
  },
  methods: {
    async addCompanyToChannel(channel) {
      if (null === this.company) {
        return;
      }

      const channelName = this.getChannelName(channel.uuid);
      let channelUuidForRemove = null;
      if (channelName === 'company.not-relevant' && this.addedToChannel[this.relevantCompaniesChannelUuid]) {
        channelUuidForRemove = this.relevantCompaniesChannelUuid;
      }

      if (channelName === 'company.relevant' && this.addedToChannel[this.notRelevantCompaniesChannelUuid]) {
        channelUuidForRemove = this.notRelevantCompaniesChannelUuid;
      }

      if (channelUuidForRemove !== null) {
        try {
          await this.$store.dispatch("removeCompanyFromChannel", {
            company: this.company,
            channelUuid: channelUuidForRemove
          });
          delete this.addedToChannel[channelUuidForRemove]
        } catch (e) {
          return;
        }
      }

      try {
        this.$store.dispatch("addCompanyToChannel", {company: this.company, channelUuid: channel.uuid});
        this.addedToChannel[channel.uuid] = true

        if (_get(this.getCurrentMemberProfile(), 'preferences.autoMarkedAsRelevant', true)
            && !this.addedToChannel[this.relevantCompaniesChannelUuid]
            && channelName !== 'company.not-relevant'
            && channelName !== 'company.relevant') {
          this.$store.dispatch("addCompanyToChannel", {
            company: this.company,
            channelUuid: this.relevantCompaniesChannelUuid
          });
          this.addedToChannel[this.relevantCompaniesChannelUuid] = true;
        }
      } catch (e) {
      }
    },

    createChannel() {
      this.$store.dispatch("createCompanyChannel", {channelName: this.newListName})
          .then(function (channel) {
            this.addCompanyToChannel(channel);
            this.displayCreateListDialog = false;
            this.$emit('close');
          }.bind(this));
    },

    displayCreateNewListDialog() {
      this.displayCreateListDialog = true;
    },

    getChannelsForCompany(companyId) {
      let channels = {};
      for (const channel of this.getCompanyChannels) {
        if (channel.items === undefined) {
          console.log('Items for channel not found: ' + channel.uuid)
          continue;
        }
        if (-1 !== channel.items.findIndex(n => n.referrerObject === companyId)) {
          channels[channel.uuid] = true;
        }
      }
      return channels;
    },

    ...mapGetters({
      getCurrentMemberProfile: 'getCurrentMemberProfile',
    }),
  },

  computed: {
    ...mapState({
      currentViewChannel: 'currentViewChannel',
    }),

    ...mapGetters({
      relevantCompaniesChannelUuid: 'getRelevantCompaniesChannelUuid',
      notRelevantCompaniesChannelUuid: 'getNotRelevantCompaniesChannelUuid',
      getCompanyChannels: 'getCompanyChannels',
      getChannelName: 'getChannelName',
      getChannelCompanies: 'getChannelCompanies',
    }),
  }
}
</script>
